import { render, staticRenderFns } from "./dialog-checksetting.vue?vue&type=template&id=0155aa0a&"
import script from "./dialog-checksetting.vue?vue&type=script&lang=js&"
export * from "./dialog-checksetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports